require('./iframe-modal.component.scss');

export class IFrameModal {
  constructor($scope, $modalInstance) {
    $scope.ok = () => {
      $modalInstance.close();
    };
    $scope.cancel = () => {
      $modalInstance.close();
    };
  }
}



// WEBPACK FOOTER //
// ./src/shared/iframe-modal.component.js